<template>
  <v-row justify="center">
    <v-dialog
      style="border-radius: 5px"
      v-model="show"
      persistent
      max-width="600px"
    >
      <custom-modal
        title="Create Bed Type"
        @onSubmit="SavebedType"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="12" sm="12" lg="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="Name"
                vid="name"
                rules="required"
                hide-details="auto"
              >
                <v-text-field
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  v-model="bedType.name"
                  label="Name"
                  auto-grow
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Code"
                vid="code"
                rules="required"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="bedType.code"
                  label="Code"
                  auto-grow
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import CustomModal from "@/components/base/CustomModal";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
export default {
  data: () => ({
    dialog: false,
    bedType: {
      name: "",
      code: "",
    },

    isLoading: false,
  }),
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,

    CustomModal,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.bedType);
        }
      },
    },
  },
  methods: {
    close() {
      this.show = false;
      this.bedType = new bedType();
      this.$refs.observer.reset();
    },
    async SavebedType() {
      const isValid = await this.$refs.observer.validate();
      this.bedType.isAdd = true;
      if (isValid) {
        this.CreatebedType();
      }
    },

    CreatebedType() {
      this.isLoading = true;
      this.$store
        .dispatch("bedtype/CreateBedType", this.bedType)
        .then((res) => {
          this.succeeed = true;
          this.$emit("afterSave");
          this.$toast.success("Bed Type created  succesfully");
          this.isLoading = false;
          this.show = false;
          this.bedType = {} ;
          this.$refs.observer.reset();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);

          this.$toast.error("Bed Type created  failed!");
          this.isLoading = false;
        });
    },
  },
};
</script>
